import { render, staticRenderFns } from "./ConfigAdmin.vue?vue&type=template&id=a4417e0e&"
import script from "./ConfigAdmin.vue?vue&type=script&lang=js&"
export * from "./ConfigAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports